import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { track } from '@vercel/analytics';

export const ExtraLinks: React.FC = () => {
  useEffect(() => {
    track('extra_links_redirected', { source_page: 'extra-links' });
  }, []);

  return <Navigate to="/links" replace />;
};
